// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2KuHq","input":"styles_input__peZGw"};